import React from 'react';
import Modal, {ModalHeader, ModalContent, ModalFooter} from '../../common/modal';
import Button from '../../common/button';
import TU from '../../common/tu';
import basketActions from '../../../actions/basket';
import translate from '../../../utils/translate';
import ModalCautionIcon from '../../common/icons/icon_modal_caution';
import ModalCloseIcon from '../../common/icons/icon_close2';
import OmnitureBuilder from '../../../utils/omniture-helper/omniture_builder';
import OmnitureUtils from '../../../utils/omniture-helper/omniture_utils';

const T = React.PropTypes;

export default class AvoidSingleSeatModal extends React.Component {
  static propTypes = {
    attemptedToBuyTicket: T.bool,
    hasSingleSeat: T.bool
  };

  handleDismissSingleSeatModal = () => {
    basketActions.dismissSingleSeatModal();
  };

  render () {
    if (this.props.attemptedToBuyTicket && this.props.hasSingleSeat) {
      const msg = OmnitureUtils.getOmnitureErrorMessage(OmnitureUtils.LEAVE_SINGLE_SEAT_ERROR);
      OmnitureBuilder.errorMessage(msg).sendSingle();

      return (
        <Modal
          isOpen
          className="notificationmessage"
          dataComponent="Avoid Single Seat"
          onClose={this.handleDismissSingleSeatModal}>
          <ModalHeader isWarning>
            <div className="modal__header__icon__wrapper">
              <ModalCautionIcon className="modal__header__icon--dark" />
            </div>
            <div className="modal__header_title">{translate('ismModule', 'LEAVE_SINGLE_SEAT_TITLE')}</div>
            <Button icon onClick={this.handleDismissSingleSeatModal} data-component="modal__close_button">
              <ModalCloseIcon className="modal__header__close_icon--dark" />
            </Button>
          </ModalHeader>

          <ModalContent>
            <TU text={translate('ismModule', 'JS_ISM_LEAVE_SINGLE_SEAT_DESC')} tag="div" />
          </ModalContent>

          <ModalFooter>
            <Button
              primary
              data-component="modal-btn-avoid-single-seat"
              onClick={this.handleDismissSingleSeatModal}>
              {translate('ismModule', 'OKAY')}
            </Button>
          </ModalFooter>
        </Modal>
      );
    }
    else {
      return null;
    }
  }
}



// WEBPACK FOOTER //
// ./frontend/react/components/edp/errors/avoid_single_seat.js